import clsx from "classnames";
import { Description, Title } from "@/ui";
import HighlightButtons from "./HighlightButtons";
import classes from "../styles.module.scss";

/**
 * Text side of the highlight card: heading, rich text and (optionally) the buttons.
 *
 * @param {string} [title] - Heading text.
 * @param {string} [titleColor] - Text colour class for the heading.
 * @param {string} [description] - Rich text HTML.
 * @param {string} [textColor] - Text colour class for the copy.
 * @param {Array} [buttons] - Button items rendered inside the card; empty when they sit below it.
 * @returns {JSX.Element}
 */
export default function HighlightContent({ title, titleColor, description, textColor, buttons = [] }) {
  return (
    <div className={clsx(classes.highlightBox__content, textColor)}>
      <Title title={title} tag="h2" className={clsx(classes.highlightBox__title, titleColor)} />

      <div data-sourceflow-prop="description">
        <Description description={description} className={classes.highlightBox__description} />
      </div>

      <HighlightButtons buttons={buttons} className="mt-2" />
    </div>
  );
}
